import { LoadIdView, ShipmentTransitTime } from '../../../models';

export class ShipmentTransportOrderLoadModel {
  idView: LoadIdView;
  carrier: string = null;
  lastStatus: string = null;
  deliveryLocation: string;
  transitTime: ShipmentTransitTime;
  constructor(params?: Partial<ShipmentTransportOrderLoadModel>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
